"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z
    .object({
    propertyId: zod_1.z.number(),
    cultivars: zod_1.z
        .object({
        cultivarId: zod_1.z.number(),
        fullbloomDate: zod_1.z.string().nullable(),
    })
        .array(),
})
    .array();
//# sourceMappingURL=update.js.map